module.exports = __webpack_public_path__ + "img/2025-03-06-01-01.5e57bbe8.png";